var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Heading as ThemeHeading } from "theme-ui";
import { HeadingDisplayVariants, HeadingRegularVariants } from "../../theme";
export const Heading = props => {
    return _jsx(ThemeHeading, Object.assign({}, props));
};
export const H1 = (_a) => {
    var { display, as = "h1" } = _a, props = __rest(_a, ["display", "as"]);
    return (_jsx(Heading, Object.assign({ as: as }, props, { variant: display ? HeadingDisplayVariants.first : HeadingRegularVariants.first })));
};
export const H2 = (_a) => {
    var { display, as = "h2" } = _a, props = __rest(_a, ["display", "as"]);
    return (_jsx(Heading, Object.assign({ as: as }, props, { variant: display ? HeadingDisplayVariants.second : HeadingRegularVariants.second })));
};
export const H3 = (_a) => {
    var { display, as = "h3" } = _a, props = __rest(_a, ["display", "as"]);
    return (_jsx(Heading, Object.assign({ as: as }, props, { variant: display ? HeadingDisplayVariants.third : HeadingRegularVariants.third })));
};
export const H4 = (_a) => {
    var { display, as = "h4" } = _a, props = __rest(_a, ["display", "as"]);
    return (_jsx(Heading, Object.assign({ as: as }, props, { variant: display ? HeadingDisplayVariants.fourth : HeadingRegularVariants.fourth })));
};
export const H5 = (_a) => {
    var { display, as = "h5" } = _a, props = __rest(_a, ["display", "as"]);
    return (_jsx(Heading, Object.assign({ as: as }, props, { variant: display ? HeadingDisplayVariants.fifth : HeadingRegularVariants.fifth })));
};
export const H6 = (_a) => {
    var { display, as = "h6" } = _a, props = __rest(_a, ["display", "as"]);
    return (_jsx(Heading, Object.assign({ as: as }, props, { variant: display ? HeadingDisplayVariants.sixth : HeadingRegularVariants.sixth })));
};
//# sourceMappingURL=Heading.js.map